import type { FaireProductEntity } from "../../entity_types/product";

export const p_z2pqfx2mwn: FaireProductEntity = {
  token: "p_z2pqfx2mwn",
  type: "product",
  name: "18K Gold PVD Cubic Zirconia Tennis Chain Necklace",
  brandToken: "b_99ch5ye698",
  brandName: "Unknown Brand",
  imageUrl: "https://cdn.faire.com/fastly/8d91fdb5e7e4c92854cea593c0278a8cb289e9fa3cfa633e7d4553da70e75097.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/87357db246ea330d35689312c6ab989bd9450add3189dc1211fea3f56e24c99a.jpeg",
    "https://cdn.faire.com/fastly/ae0589f84565a22807a479454ccf73ad46021a653e94d41ec6abb4c98ec3cd74.jpeg",
    "https://cdn.faire.com/fastly/7446382022256dfc35035f5f4ee3dbb5c162d0c8e521dd3e7820c65ddd7bebd7.jpeg",
    "https://cdn.faire.com/fastly/60aec120520fac2983bc496854d0159d777d7bbfc8a18aed4d6ff41e99314d82.jpeg",
    "https://cdn.faire.com/fastly/e010d488e08cda6f138f894324053e0fd05eab18b63a029d65089254180f50eb.jpeg",
    "https://cdn.faire.com/fastly/f71871672f724157acf5eae8f06c17cdc9aec56b9fbd211445ba7b3902ec43b0.jpeg",
    "https://cdn.faire.com/fastly/b30c393e26577aec14107e5d023db045845001b6263f847afe65a878454bc248.jpeg",
    "https://cdn.faire.com/fastly/367e8745e0f94eda2fd8d769848c2f4a0bbf26f23e3992cdd7c809df0d959742.jpeg",
    "https://cdn.faire.com/fastly/06e4d4d4795cec7f1550b17e0d02702e93ccb84d289a7bba76e06e2f4ede9a26.jpeg"
  ],
  priceDollars: 36,
  description: "A simple yet radiant look that is timeless for any season, the tennis chain necklace is a stunning and classic design to add to your necklace collection. Perfect for gifting to her, this tennis chain features clear Austrian cubic zirconia stones that is both radiant and crafted with premium 18K PVD stainless steel.\n\n•  100% Waterproof, non-tarnish, hypoallergenic\n•  Lightweight and designed for everyday wear\n•  Great for layering with other necklaces\n\n- PVD COATING -\nWe use the process of PVD Coating our 18K Gold jewelry over 316L surgical grade stainless steel for a non-tarnish, hypoallergenic, polished finish that will hold up best to everyday wear and will never turn your customer's skin green.\n\nApprox. Weight: 6 grams\nLength: 14\"+2\", 16\"+2\", 18\"+2\"\nWidth: 3mm",
  tags: [],
  msrpDollars: 72,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:27:00.450Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
